/**
 * usePageTracking — Sprint 20 hook for P13-retrofitted pages.
 *
 * Fetches portfolio impact + track record data for a page's topic.
 * Used across /macro-radar, /currency, /credibility, /telegram, /voices,
 * /signals, /smart-money, /mnemosyne.
 *
 * Usage:
 *   const { impact, track, loading } = usePageTracking('regime');
 *   <PortfolioImpactPanel topic="Regime" {...impact} />
 *   <TrackRecordPanel {...track} />
 */

import { useEffect, useState } from 'react';

export function usePageTracking(topic) {
  const [impact, setImpact] = useState({ affected_tickers: [], impact_summary: null });
  const [track, setTrack] = useState({
    metric_name: topic,
    hit_rate_30d: null,
    hit_rate_90d: null,
    sample_size: 0,
    trajectory: [],
    recent_calls: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      const json = async (url) => {
        try { const r = await fetch(url); return r.ok ? await r.json() : null; }
        catch { return null; }
      };

      const [impactRes, trackRes] = await Promise.all([
        json(`/api/tracking/portfolio-impact/${encodeURIComponent(topic)}`),
        json(`/api/tracking/${encodeURIComponent(topic)}`),
      ]);
      if (cancelled) return;

      if (impactRes) setImpact(impactRes);
      if (trackRes) setTrack(trackRes);
      setLoading(false);
    }
    load();
    return () => { cancelled = true; };
  }, [topic]);

  return { impact, track, loading };
}
